import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as moment from 'moment';
import ASpaceInBetweenAnother from '../ASpaceInBetweenAnother/a.space.inbetween.another.vue';
import { LPCoverFactory } from '../../pages/LPCreatePage/factory';

@Component({
    components: {
        ASpaceInBetweenAnother
    }
})
export default class LPThanksLetter extends Vue {
    public title: string = 'LPThanksLetter';

    public date: string = moment().format('MMMM Do, YYYY');

    @Prop({
        default: () => {
            return LPCoverFactory.addrFactory();
        }
    })
    public addr: any;

    @Prop({
        default: () => {
            return LPCoverFactory.preparedForFactory();
        }
    })
    public preparedFor: any;

    @Prop({
        default: () => {
            return LPCoverFactory.preparedByFactory();
        }
    })
    public preparedBy: any;

    @Prop({
        default: () => {
            return LPCoverFactory.agentBrokerageFactory();
        }
    })
    public agentBrokerage: any;

    @Prop({ default: undefined })
    public data: any;

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }
}
